import React from "react";

const CardCarPlaceholder = () => {
  return (
    <>
      <style>
        {`
          .card-placeholder {
            padding: 1.25rem;
            border: 2px solid #d1d5db;
            width: 320px;
            height: 100%;
            border-radius: 1rem;
            background-color: #f0f0f0;
            animation: pulse 2s infinite ease-in-out;
          }

          .card-placeholder .image-placeholder {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #d1d5db;
            height: 12rem;
            width: 100%;
            margin-bottom: 1rem;
          }

          .card-placeholder .spinner {
            width: 7rem;
            height: 7rem;
            animation: spin 2s linear infinite;
            color: #e5e7eb;
            font-size: 1.5rem;
          }

          .card-placeholder .text-placeholder {
            text-align: center;
            background-color: #d1d5db;
            height: 1.5rem;
            width: 100%;
            border-radius: 0.375rem;
            margin-bottom: 1rem;
          }

          .card-placeholder .table-placeholder {
            width: 100%;
            border-collapse: collapse;
          }

          .card-placeholder .table-placeholder td {
            padding: 0.5rem;
            background-color: #e5e7eb;
            height: 2rem;
          }

          .card-placeholder .table-placeholder tr:nth-child(even) td {
            background-color: #f3f4f6;
          }

          .card-placeholder .table-placeholder tr:nth-child(odd) td {
            background-color: #e5e7eb;
          }

          .card-placeholder .button-placeholder {
            background-color: #d1d5db;
            height: 2.5rem;
            width: 100%;
            border-radius: 0.375rem;
            margin-top: 1rem;
          }

          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <div className="card-placeholder">
        <div className="image-placeholder">
          <svg
            aria-hidden="true"
            className="spinner"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="absolute font-bold">Cargando...</span>
        </div>
        <h1 className="text-center text-xl bg-gray-300 h-6 rounded mb-4"></h1>
        <div className="h-full">
          <div className="bg-gray-300 h-8 w-full mb-4"></div>
          <table className="table-placeholder">
            <tbody>
              <tr>
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr>
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr>
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr>
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
              <tr className="bg-gray-50">
                <td className="p-2"></td>
                <td className="p-2"></td>
              </tr>
            </tbody>
          </table>
          <div className="button-placeholder"></div>
        </div>
      </div>
    </>
  );
};

export default CardCarPlaceholder;
